module.exports = __webpack_public_path__ + "img/lunch.7315b4f1.jpg";